module.exports = __webpack_public_path__ + "img/Allec-New-Logo-M.c093ce88.png";